var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/phone_number/index.js
// module id = 2005
// module chunks = 2